import React from 'react';
import { KineduPalette } from 'kinedu-react-components';
import { Button, Modal, Spinner } from 'lego-dist';
import StylesDialogWrapper from './styles/StylesDialogWrapper';
import ChildrenContent from './styles/ChildrenContent';
import ButtonWrapper, { SpinnerContent } from './styles/ButtonWrapper';

interface IDialogProps {
  StylesDialog?: {
    StylesDialog?: string,
    StylesContent?: string,
    StylesButtonWrapper?: string,
  };
  className?: string;
  show?: boolean;
  loading?: boolean;
  title?: any;
  onDialogClose?: any;
  children?: any;
  hiddenDefaultBtns?: boolean;
  hiddenCloseBtn?: boolean;
  mainText?: string;
  onMainAction?: any;
  cancelText?: string;
  onCancelAction?: any;
  closeOnBackdrop?: boolean;
}

const Dialog: React.FC<IDialogProps> = ({
  StylesDialog = {},
  className,
  show = false,
  title,
  loading = false,
  onDialogClose,
  children,
  hiddenDefaultBtns = false,
  hiddenCloseBtn = false,
  mainText,
  onMainAction,
  cancelText,
  onCancelAction,
  closeOnBackdrop,
}) => (
  <Modal
    roundedCorners
    showCloseButton={!hiddenCloseBtn}
    className={className}
    openModal={show}
    title={title}
    onClosedModal={() => {
      if (onDialogClose) onDialogClose();
    }}
    closeOnBackdrop={closeOnBackdrop}
  >
    {() => (
      <StylesDialogWrapper StylesDialog={StylesDialog.StylesDialog}>
        <ChildrenContent StylesContent={StylesDialog.StylesContent}>
          {children}
        </ChildrenContent>
        { !hiddenDefaultBtns
          ? (
            <ButtonWrapper StylesButtonWrapper={StylesDialog.StylesButtonWrapper}>
              { cancelText && !loading
                ? (
                  <Button
                    className="Button ButtonCancelAction"
                    outline
                    color={KineduPalette.shadeMediumDark}
                    rounded
                    small
                    onClick={() => {
                      if (onCancelAction) onCancelAction();
                    }}
                  >
                    {cancelText}
                  </Button>
                )
                : null }
              { mainText && !loading
                ? (
                  <Button
                    className="Button ButtonMainAction"
                    outline
                    color={KineduPalette.health}
                    rounded
                    small
                    onClick={() => {
                      if (onMainAction) onMainAction();
                    }}
                  >
                    {mainText}
                  </Button>
                )
                : null }
              {loading
                ? (
                  <SpinnerContent>
                    <Spinner
                      loading={loading}
                      position="absolute"
                      name="threedots"
                      color={KineduPalette.kineduShade}
                      bgColor="rgba(255,255,255,0.4)"
                    />
                  </SpinnerContent>
                )
                : null}
            </ButtonWrapper>
          )
          : null
        }
      </StylesDialogWrapper>
    )}
  </Modal>
);

export default Dialog;
